// meetingRooms/components/prices/container.js - Fixed to properly call hook with meetingRoomSlug
import React, { useState } from 'react';
import PricingView from './view';

const PricingContainer = ({ 
  resource,
  tariffs,
  isLoadingTariffs,
  showNewTariffForm,
  isSavingPricing,
  onUpdateTariff, // Hook function for optimistic updates
  venueInfo,
  showSnackbar,
  // All other props - keep for compatibility
  ...otherProps
}) => {
  const [isVatInclusive, setIsVatInclusive] = useState(false);
  const [tariffError, setTariffError] = useState('');

  // Toggle new tariff form visibility - not needed for update only
  const toggleNewTariffForm = () => {
    // No-op since we're focusing on updates only
  };

  // Handle tariff update - use hook function for smooth updates
  const handleTariffUpdated = async (tariffSlug, tariffData) => {
    try {
      if (onUpdateTariff) {
        // Use hook function with correct parameters: (meetingRoomSlug, tariffSlug, tariffData)
        await onUpdateTariff(resource.slug, tariffSlug, tariffData);
      } else {
        // Fallback - show success message
        if (showSnackbar) {
          showSnackbar('Tariff updated successfully!', 'success');
        }
      }
    } catch (error) {
      console.error('Error updating tariff:', error);
      if (showSnackbar) {
        showSnackbar('Failed to update tariff', 'error');
      }
    }
  };

  return (
    <PricingView
      resource={resource}
      venueInfo={venueInfo}
      tariffs={tariffs || []}
      isVatInclusive={isVatInclusive}
      isLoadingTariffs={isLoadingTariffs || false}
      tariffError={tariffError}
      showNewTariffForm={false} // No new tariff creation
      vatRate={20}
      showSnackbar={showSnackbar}
      setIsVatInclusive={setIsVatInclusive}
      setTariffError={setTariffError}
      toggleNewTariffForm={toggleNewTariffForm}
      // Only update function - no create/delete
      handleTariffUpdated={handleTariffUpdated}
      handleTariffCreated={() => {}} // No-op
      handleTariffDeleted={() => {}} // No-op
    />
  );
};

export default PricingContainer;